import { getAttribution } from '@/utils/attribution';

import type { TrackingContext } from '../_types';
import { buildBookAppointmentPayload } from './buildBookAppointmentPayload';

export const buildGaBookAppointmentPayload = (
  context: TrackingContext | undefined,
): Record<string, unknown> | null => {
  const payload = buildBookAppointmentPayload(context);
  if (!payload) return null;
  const attribution = getAttribution();
  if (attribution?.gclid) payload.gclid = attribution.gclid;
  if (attribution?.gbraid) payload.gbraid = attribution.gbraid;
  if (attribution?.wbraid) payload.wbraid = attribution.wbraid;
  if (attribution?.utmSource) payload.utm_source = attribution.utmSource;
  if (attribution?.utmMedium) payload.utm_medium = attribution.utmMedium;
  if (attribution?.utmCampaign) payload.utm_campaign = attribution.utmCampaign;
  if (attribution?.utmTerm) payload.utm_term = attribution.utmTerm;
  if (attribution?.utmContent) payload.utm_content = attribution.utmContent;
  return payload;
};
